import React from 'react';
import { ErrorScreen } from 'nallian-shared-ui/lib/modules';

const OrganisationsErrorPage = () => <ErrorScreen titleText="Organisations Admin" />;

export default OrganisationsErrorPage;
